<template>
    <div class="employee-tab-inner leave-align-mobile roster-ess-summary">
        <div class="employee-tab-inner">
            <div class="row no-margin leave-summery">

                <div class="col-md-12 px-0">
                    <div class="ibox col-md-12 h-100 mb-0 pb-2">
                        <div class="ibox-title dashboard_title">
                            <span class="text-center">Attendance Summary</span>
                        </div>
                        <div class="row wrapper no-gutters">

                            <div class="col-12 col-md-4 mb-2 mb-md-0 px-2">
                                <div class="clearfix attendance-stat-card bg-white stat-card stat-card-absent border">
                                    <div class="conteiner-1">
                                        <div class="text-muted stat-card-label">Days Absent</div>
                                        <div class="value stat-card-value">
                                            {{ leave_attendance_report.absent != undefined ? leave_attendance_report.absent : 0 }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 col-md-4 mb-2 mb-md-0 px-2">
                                <div class="clearfix attendance-stat-card bg-white stat-card stat-card-late border">
                                    <div class="conteiner-1">
                                        <div class="text-muted stat-card-label">Days Late</div>
                                        <div class="value stat-card-value">
                                            {{ leave_attendance_report.total_late_check_in != undefined ? leave_attendance_report.total_late_check_in : 0 }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 col-md-4 mb-2 mb-md-0 px-2">
                                <div class="clearfix attendance-stat-card bg-white stat-card stat-card-left-early border">
                                    <div class="conteiner-1">
                                        <div class="text-muted stat-card-label">Days Left Early</div>
                                        <div class="value stat-card-value">
                                            {{ leave_attendance_report.total_early_checkout != undefined ? leave_attendance_report.total_early_checkout : 0 }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="col-md-12 px-0 mt-3">
                    <div class="ibox col-md-12 h-100 mb-0 pb-4 pt-1">
                        <div class="ibox-title dashboard_title">
                            <span class="text-center">Leave Summary</span>
                        </div>
                        <div class="row leave-summery-count px-5">
                            <div class="col-md-5 doughnut-leave">

                                <template v-if="doughnutDatas != null">
                                    <doughnut-chart :chart-data="doughnutDatas" :options="options_doughnut"
                                        :styles="myStyles_doughnut" class="doughnut-wrapper pb-2"></doughnut-chart>
                                </template>

                                <div class="doughnut-leave-data">
                                    <div class="count">
                                        <span class="first">
                                            <template
                                                v-if="leave_attendance_report.approved_leaves != undefined">{{ leave_attendance_report.approved_leaves }}</template>
                                            <template v-else>0</template>
                                        </span>
                                        <span class="second">/</span>
                                        <span class="third">
                                            <template
                                                v-if="leave_attendance_report.allowed_leaves != undefined">{{ leave_attendance_report.allowed_leaves }}</template>
                                            <template v-else>0</template>
                                        </span>
                                    </div>
                                    <div class="text">Leaves Taken</div>
                                </div>

                            </div>
                            <div class="col-md-7 align-items-center">
                                <div class="leave-summery-container ibox mb-4 pt-2 radius-8 bg-white mt-1">
                                    <div class='leave-summery-list allowed mx-4 px-0 border-bottom py-1 d-flex align-items-center justify-content-between' v-if="carry == 1">
                                        <span class='text d-flex align-items-center'> <i class="fa fa-circle mr-1 blue-circle"></i> Carried Leaves:</span><span class='value float-right font-weight-bold blue-text'>
                                            <template
                                                v-if="leave_attendance_report.carried_leaves != undefined">{{ leave_attendance_report.carried_leaves }}</template>
                                            <template v-else>0</template>
                                        </span>
                                    </div>
                                    <div class='leave-summery-list allowed mx-4 px-0 border-bottom py-1 d-flex align-items-center justify-content-between'>
                                        <span class='text d-flex align-items-center'> <i class="fa fa-circle mr-1 blue-circle"></i> Allowed Leaves:</span>
                                        <span class='value float-right font-weight-bold blue-text'>
                                            <template
                                                v-if="leave_attendance_report.allowed_leaves != undefined">{{ leave_attendance_report.allowed_leaves }}</template>
                                            <template v-else>0</template>
                                        </span>
                                    </div>
                                    <div class='leave-summery-list approved mx-4 px-0 border-bottom py-1 d-flex align-items-center justify-content-between'>
                                        <span class='text d-flex align-items-center'> <i class="fa fa-circle mr-1 sky-circle"></i> Applied Leaves:</span><span class='value float-right font-weight-bold blue-text'>
                                            <template
                                                v-if="leave_attendance_report.applied_leaves != undefined">{{ leave_attendance_report.applied_leaves }}</template>
                                            <template v-else>0</template>
                                        </span>
                                    </div>
                                    <div class='leave-summery-list approved mx-4 px-0 py-1 d-flex align-items-center justify-content-between'>
                                        <span class='text d-flex align-items-center'> <i class="fa fa-circle mr-1 sky-circle"></i> Leaves Taken:</span><span class='value float-right font-weight-bold blue-text'>
                                            <template
                                                v-if="leave_attendance_report.approved_leaves != undefined">{{ leave_attendance_report.approved_leaves }}</template>
                                            <template v-else>0</template>
                                        </span>
                                    </div>
                                    <div class='leave-summery-line'></div>
                                    <div class='leave-summery-total px-4 radius-10 py-1'>
                                        <span class='text'>Leaves Remaining:</span><span class='value float-right font-weight-bold blue-text'>
                                            <template
                                                v-if="leave_attendance_report.remaining_leaves != undefined">{{ leave_attendance_report.remaining_leaves }}</template>
                                            <template v-else>0</template>
                                        </span>
                                    </div>
                                </div>
                                <div class="btn btn-primary cursor-pointer leave-button" @click="addLeave()">
                                    <img src="/images/la/Apply for leave - Default.svg" alt="">
                                    Apply For Leave
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <b-modal id="bv-modal-add-leave-profile" size="xl" dialog-class="w-1200" scrollable hide-footer>
            <template #modal-title>
                <div class="leave-profile wrapper">
                    <div class="leave-profile header">
                        Application for Leave
                    </div>
                    <div class="leave-profile sub-header">
                        {{leave_limit}}
                    </div>
                </div>
            </template>
            <roster-ess-employee-leave-details :editflg="0" v-on:childToParent="reloadMe">
            </roster-ess-employee-leave-details>
        </b-modal>

    </div>

</template>

<script>
    import moment from 'moment';
    export default {

        mounted() {
            this.$refs.trzcalendar;

            //alert( moment().year() +'>>'+ moment().month());
        },
        props: [],
        components: {

        },
        data() {

            const now = new Date();
            const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
            const maxDate = new Date(today);
            maxDate.setMonth(maxDate.getMonth());

            const minDate = new Date(today)
            minDate.setMonth(minDate.getMonth());
            minDate.setDate(1);
            return {
                activateKey: 0,
                attendance_date: "",
                cu: window.location.href,
                ce: true,
                page: {
                    month: '',
                    year: ''
                },
                doughnutDatas: null,
                options_doughnut: null,
                myStyles_doughnut: null,
                leave_limit: '',

                max: maxDate,
                min: minDate,
                successmsg: '',
                errormsg: [],
                fdata: {
                    check_in: null,
                    checkout: null,
                    absent: 0,
                    attendances_date: ''
                },
                show_lg: 0,
                componentKey: 0,
                carry: 0,

                avatar_src: '',
                employee_name: '',
                date_of_birth: '',
                gender: '',
                employee_code: '',
                branch_name: '',
                employee_jobposition: '',
                employee_department: '',
                leave_policy: '',
                employee_email: '',
                employee_phone: '',

                dp_today: new Date(),

                weekly_holidays: [6],
                first_day_of_week: 7,
                this_month_holidays: [],
                week_holidays: [6],
                all_week_holidays: [6],
                holidays_date_arr: [],

                header_year_month: '',

                start_date: null,
                end_date: null,

                total_working_day: 0,
                total_weekends: 0,
                total_holidays: 0,
                total_absent: 0,
                total_leaves: 0,

                leave_available: [],

                leave_attendance_report: [],

                total_leaves_available: 0,
                total_leaves_remaining: 0,
                total_leaves_taken: 0,

                /*Aboni edit starts*/
                attendances: [],
                week_days_header: [],
                length_options: [],
                today_index: 0,
                attendances_date: null,

                check_in: null,
                checkout: null,
                work_time: 0,
                break_time: 0,
                over_time: 0,
                activity_log: null,

                attendances_date2: null,

                check_in2: null,
                checkout2: null,
                work_time2: 0,
                break_time2: 0,
                over_time2: 0,
                activity_log2: null,

                edit_date: null,
                employee_id: 0,

                /*Aboni edit ends*/
                masks: {
                    title: 'MMMM YYYY',
                    weekdays: 'W',
                    navMonths: 'MMM',
                    input: ['L', 'YYYY-MM-DD', 'YYYY/MM/DD'],
                    dayPopover: 'WWW, MMM D, YYYY',
                    data: ['L', 'YYYY-MM-DD', 'YYYY/MM/DD'],
                },

                attributes: [{
                    dates: new Date(),
                }],

                page: {
                    month: '',
                    year: ''
                },
                leave_limit: '',

            }
        },
        methods: {

            doughnutData(approved, allowed) {
                this.doughnutDatas = {
                    labels: ['Approved Leaves', 'Allowed Leaves'],
                    datasets: [{
                        data: [approved, allowed],
                        borderColor: ['#76C9D3', '#3A52A5'],
                        backgroundColor: ['#76C9D3', '#3A52A5'],
                        borderWidth: 4
                    }]
                };

                this.options_doughnut = {
                    responsive: true,
                    maintainAspectRatio: true,
                    cutoutPercentage: 85,
                    legend: {
                        display: false
                    },
                    tooltips: {
                        callbacks: {
                            title: function (tooltipItem, data) {
                                return data['labels'][tooltipItem[0]['index']];
                            },
                            label: function (tooltipItem, data) {
                                return data['datasets'][0]['data'][tooltipItem['index']].toLocaleString();
                            },
                        },
                    }
                };

                this.myStyles_doughnut = {
                    width: '90%',
                    position: 'relative',
                };
            },
            reloadMe: function (data) {
                this.$bvModal.hide('bv-modal-add-leave-profile');
                this.getLeaveAttendanceReport();
                this.componentKey += 1;

            },
            validateState(ref) {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            dateDisabled(ymd, date) {
                const x = moment(String(date)).format('YYYY-MM-DD');
                const weekday = date.getDay();
                return this.all_week_holidays.includes(weekday) || this.holidays_date_arr.includes(x);
            },

            addLeave() {
                this.$bvModal.show('bv-modal-add-leave-profile');
            },
            getLeaveAttendanceReport: function () {
                //leave_attendance_report
                if (!this.checkNet()) return false;

                axios.get(this.$api_url + '/front/leave-attendance/leave/attendances/report/fiscalyear').then(
                    function (response) {

                        this.leave_attendance_report = response.data;
                        this.doughnutData(this.leave_attendance_report.approved_leaves, this
                            .leave_attendance_report.allowed_leaves);

                    }.bind(this));
            },
            monthDetails: function (x = '', y = 0, m = 0) {
                let year;
                let month;

                if (y == 0) {
                    year = x['year'];
                    month = x['month'];
                } else {
                    year = y;
                    month = m;
                }

                let st_date = new Date(year, month - 1, 1);
                let en_date = new Date(year, month, 0);
                this.start_date = moment(String(st_date)).format('Do MMMM YYYY');
                this.end_date = moment(String(en_date)).format('Do MMMM YYYY');

                // fetch holidays dynamically from controller
                axios.get(this.$api_url + '/front/leave-attendance/employee/attendances/details', {
                    params: {
                        st_date: this.start_date,
                        en_date: this.end_date,
                    }
                }).then((response) => {

                    this.all_week_holidays = response.data.report.week_holidays.split(',').map(function (
                        item) {
                        return parseInt(item, 10);
                    });
                    this.holidays_date_arr = response.data.report.holidays_date_arr.split(',').map(
                        function (item) {
                            return item;
                        });
                    this.weekly_holidays = response.data.report.week_holidays.split(',').map(function (
                    item) {
                        return parseInt(item, 10) + 1;
                    });
                    this.first_day_of_week = parseInt(response.data.report.week_start_day) + 1;
                    this.this_month_holidays = response.data.holidays;
                    this.total_working_day = response.data.report.total_working_day;
                    this.total_weekends = response.data.report.weekends;
                    this.total_holidays = response.data.report.holidays;
                    this.total_absent = response.data.report.absent;
                    this.total_leaves = response.data.report.total_leaves;
                }).catch((error) => {
                    this.serverError(error);
                });
            },

            getCompanyLeaveSettings:function()
            {
              if(!this.checkNet()) return false;
              axios.get(this.$api_url+'/front/leave-attendance/company/leave/settings').then(function(response){

                  if(response.data.length != 0)
                  {
                      this.carry = response.data.carry;
                  }
              }.bind(this));
            },
        },
        created: function () {
            this.getLeaveAttendanceReport();
            this.getCompanyLeaveSettings();
        },
        computed: {
            fetchStartWeekday() {
                return parseInt(this.first_day_of_week) - 1;
            },
        }
    }
</script>
